import styled from 'styled-components';
export const Wrapper = styled.span `
  display: inline-block;
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.critical100};
`;
